import { useEffect, useState } from "react";
import { getReadings, Reading } from "./api";
import AtmosphericData from "./AtmosphericData";
import Graph from "./Graph";


function fillNulls(data: Reading[]) {
  var i = 0;
  while (i < data.length - 1) {
    if (data[i + 1].timestamp.getTime() - data[i].timestamp.getTime() > 60000) {
      const newReading: Reading = {
        timestamp: new Date(data[i].timestamp.getTime() + 60000),
        temperature: null,
        humidity: null,
        pressure: null,
      };
      data.splice(i + 1, 0, newReading);
    }
    i++;
  }
}

async function fetchReadings(begin?: Date) {
  try {
    const data = await getReadings(begin);
    data.forEach((reading: any) => {
      reading.timestamp = new Date(reading.timestamp / 1000000);
      reading.temperature = Math.round(reading.temperature * 100) / 100;
      reading.humidity = Math.round(reading.humidity * 100) / 100;
      reading.pressure = Math.round(reading.pressure * 100) / 100;
    });
    fillNulls(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

export default function HowColdIsMyRoom() {
  useEffect(() => {
    document.title = "How cold is my room?";
  }, []);

  const [readings, setReadings] = useState<Array<Reading>>([]);

  useEffect(() => {
    const lastWeek = new Date();
    lastWeek.setDate(lastWeek.getDate() - 7);
    fetchReadings(lastWeek).then((data) => {
      if (data) {
        setReadings(data);
      }
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const lastReading = readings[readings.length - 1]?.timestamp;
      fetchReadings(lastReading).then((data) => {
        if (data) {
          fillNulls([readings[readings.length - 1], ...data]);
          setReadings([...readings, ...data.slice(1)]);
        }
      })
    }, 5000);
    return () => clearInterval(interval);
  }, [readings]);

  return (
    <div>
      <h1>How cold is my room?</h1>
      <AtmosphericData reading={readings[readings.length - 1]} />
      <Graph data={readings} data_key={"temperature"} colour={"#8884d8"} />
      <Graph data={readings} data_key={"pressure"} colour={"#82ca9d"} />
      <Graph data={readings} data_key={"humidity"} colour={"#82009d"} max_y={100} />
    </div>
  );
}
